import { MatrixAxis, MatrixDtoAttributes } from "./Matrix"
import { MatrixItemDto } from "./matrix-item/MatrixItem"
import { MatrixAxisOptionDto } from "./matrix-axis-option/MatrixAxisOption"
import { MATRIX_AXIS_TYPE, MATRIX_ITEM_STATUS } from "../Types"
import { PricingBracketsDto } from "../pricingbrackets/PricingBrackets"
import produce from "immer"
import { CurrencyPricingDtoAttributes } from "../currencypricing/CurrencyPricing"

export const NewMatrixRequestDto = (matrix: MatrixDtoAttributes): MatrixRequestDto => {
    return {
        xAxis: NewMatrixAxisRequestDto(matrix.axes, MATRIX_AXIS_TYPE.X),
        yAxis: NewMatrixAxisRequestDto(matrix.axes, MATRIX_AXIS_TYPE.Y),
        zAxis: NewMatrixAxisRequestDto(matrix.axes, MATRIX_AXIS_TYPE.Z),
        //todo add other axis
        items: NewMatrixItemsRequestDto(matrix.items, matrix.parentProductId),
    }
}

export type MatrixRequestDto = {
    xAxis: MatrixAxisRequestDto
    yAxis: MatrixAxisRequestDto
    zAxis: MatrixAxisRequestDto
    items: MatrixItemRequestDto[]
}

const NewMatrixAxisRequestDto = (axes: MatrixAxis[], axisType: MATRIX_AXIS_TYPE): MatrixAxisRequestDto => {
    const axis = axes.find(axis => axis.type == axisType)
    if (axis) {
        return {
            name: axis.name,
            options: NewMatrixOptionRequestDto(axis.options)
        }
    }
    return {
        name: "",
        options: []
    }
}

type MatrixAxisRequestDto = {
    name: string
    options: MatrixAxisOptionRequestDto[]
}

const NewMatrixOptionRequestDto = (options: MatrixAxisOptionDto[]): MatrixAxisOptionRequestDto[] => {
    if (!options) return []
    return options.map(o => {
        return {
            id: o.id,
            name: o.attributes.name,
            orderBy: o.attributes.orderBy
        }
    })

}

type MatrixAxisOptionRequestDto = {
    id: string
    name: string
    orderBy: number
}

const isItemNewAndDeleted = (item: MatrixItemDto): boolean => {
    return item.attributes.status_ === MATRIX_ITEM_STATUS.NEW && item.attributes.deleted
}

const NewMatrixItemsRequestDto = (items: MatrixItemDto[], parentProductId: string): MatrixItemRequestDto[] => {
    return items.filter((item) => !isItemNewAndDeleted(item)).map(item => {
        // @ts-ignore todo update this logic when global state is split and simplified
        const multiCurrency = item.attributes.product.attributes.multiCurrencyPricing.map(mc =>
            // @ts-ignore
            mc.attributes || mc) as CurrencyPricingDtoAttributes[]
        return {
            unitPrice: item.attributes.product.attributes.defaultUnitPrice,
            unitCost: item.attributes.product.attributes.defaultUnitCost,
            xMatrixAxisOptionId: item.attributes.xMatrixAxisOptionId,
            yMatrixAxisOptionId: item.attributes.yMatrixAxisOptionId,
            zMatrixAxisOptionId: item.attributes.zMatrixAxisOptionId,
            isDeleted: item.attributes.deleted,
            multiCurrencyPricing: multiCurrency,
            pricingBrackets: NewPricingBracketsRequestDto(item.attributes.product.attributes.pricingBrackets),
            monthlyUnitCost: item.attributes.product.attributes.monthlyUnitCost,
            monthlyUnitPrice: item.attributes.product.attributes.monthlyUnitPrice,
            yearlyUnitCost: item.attributes.product.attributes.yearlyUnitCost,
            yearlyUnitPrice: item.attributes.product.attributes.yearlyUnitPrice,
            productId: item.attributes.productId,
            productTitle: item.attributes.product.attributes.title,
            parentProductId: parentProductId,
        }
    })
}

const NewPricingBracketsRequestDto = (brackets: (PricingBracketsDto | PricingBracketRequestDto)[]):
    PricingBracketRequestDto[] => {
    if (!brackets) return []
    // @ts-ignore todo update this logic when global state is split and simplified
    const bracketsDtoAttributes = brackets.map(b => b.attributes || b) as PricingBracketRequestDto[]
    return bracketsDtoAttributes.map(b => {
        return produce(b, draft => {
            draft.multiCurrencyPricing = draft.multiCurrencyPricing.map(mc => mc.attributes ? mc.attributes : mc)
        })
    })
}

type MatrixItemRequestDto = {
    unitPrice: string
    unitCost: string
    xMatrixAxisOptionId: string
    yMatrixAxisOptionId: string
    zMatrixAxisOptionId: string
    isDeleted: boolean
    multiCurrencyPricing: CurrencyPricingDtoAttributes[]
    pricingBrackets: PricingBracketRequestDto[]
    monthlyUnitCost: string
    monthlyUnitPrice: string
    yearlyUnitCost: string
    yearlyUnitPrice: string
    productId: string
}

export type PricingBracketRequestDto = {
    id: string
    fromMeasure: string
    toMeasure: string
    cost: string
    price: string
    sequence: string
    monthlyCost: string
    monthlyPrice: string
    yearlyCost: string
    yearlyPrice: string
    // @ts-ignore todo update this logic when global state is split and simplified
    multiCurrencyPricing: CurrencyPricingDtoAttributes[] | PricingBracketsDto[]
}



// WEBPACK FOOTER //
// ./src/state/product/matrix/MatrixDto.ts